module.exports = __webpack_public_path__ + "static/news-68ad47e4f261bbd3a5170c5c0c38e380.png";